import { Anchor } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { useContactInfoPopup } from '@/hooks/useContactInfoPopup'
import { WorkspaceMember, WorkspaceMemberRole } from '@/types/workspace'
import { WorkspaceSelectHandler } from '../WorkspaceSelect/WorkspaceSelectHandler'
import { WorkspaceAlertWithLogout } from './WorkspaceAlertWithLogout'

type NoSubscriptionAlertProps = {
  activeMembership?: WorkspaceMember
  activeWorkspaces: WorkspaceMember[]
}

export const NoSubscriptionAlert = ({
  activeMembership,
  activeWorkspaces
}: NoSubscriptionAlertProps) => {
  const { open: openContactInfo } = useContactInfoPopup()

  const message =
    activeMembership && activeMembership.role !== WorkspaceMemberRole.Owner ? (
      <FormattedMessage
        id="subscriptions.noActiveSubscription.member"
        values={{
          workspaceName: activeMembership.workspace.name
        }}
      />
    ) : (
      <FormattedMessage
        id="subscriptions.noActiveSubscription.owner"
        values={{
          link: (chunks) => (
            <Anchor
              size="xs"
              underline="always"
              component="button"
              type="button"
              onClick={openContactInfo}
            >
              {chunks}
            </Anchor>
          )
        }}
      />
    )

  return (
    <WorkspaceAlertWithLogout
      message={message}
      extraContent={
        activeWorkspaces.length > 1 && (
          <WorkspaceSelectHandler
            selectProps={{
              label: <FormattedMessage id="workspace.switch" />,
              styles: (theme) => ({
                option: {
                  padding: theme.spacing.sm
                }
              })
            }}
          />
        )
      }
    />
  )
}
